module.exports = __webpack_public_path__ + "static/media/search.33cf7b2b.svg";